import React, { useRef, useEffect, useState } from 'react';
import ProductListStyled from './ProductListStyled';
import { Box, useTheme } from '@material-ui/core';
import SvgIcon from '@/components/SvgIconML/SvgIconML';
import { fmtThousand, fmtPercent } from '@/utils/comUtil';
import { useSelector } from 'dva';
import Loading from '@/components/LoadingML/LoadingML';
import NoData from '@/components/no_data_show/NoData';
import TooltipsML from '@/components/TooltipsML/TooltipsML';
import { useIntl } from 'umi';

let rightInt = null,
  leftInt = null,
  mouseAn = null,
  startTime = 1000; //开始轮播的时间
const ProductList = () => {
  const productListRef = useRef(null);
  const productListBoxRef = useRef(null);
  const [status, setStatus] = useState();
  const theme = useTheme();
  const intl = useIntl();
  const { formatMessage } = intl;
  const productList = useSelector((state) => state.bhc.productList);
  // console.log('productList:', productList);

  const loadingEffect = useSelector((state) => state.loading);
  const loading = loadingEffect.effects['bhc/getHotProduct'];

  // 轮播图右边按钮
  const handleMovetoRight = () => {
    // const len=productList.length;
    // width:175
    clearInterval(leftInt);
    clearInterval(rightInt);
    const wrap = document.getElementsByClassName('product-wrap')[0];
    const productListRefW = productListRef?.current?.offsetWidth;
    const productListBoxRefW = productListBoxRef?.current?.offsetWidth;
    let left = Number(wrap.offsetLeft);
    leftInt = setInterval(() => {
      if (productListBoxRefW - left - 14 < productListRefW) {
        left -= 1;
        Object.assign(wrap.style, {
          left: left + 'px',
        });
      } else {
        clearInterval(leftInt);
      }
    }, 10);
  };

  // 轮播图左边按钮
  const handleMovetoLeft = () => {
    clearInterval(leftInt);
    clearInterval(rightInt);
    const wrap = document.getElementsByClassName('product-wrap')[0];
    let left = Number(wrap.offsetLeft);
    rightInt = setInterval(() => {
      if (left < 0) {
        left += 1;
        Object.assign(wrap.style, {
          left: left + 'px',
        });
      } else {
        clearInterval(rightInt);
      }
    }, 10);
  };

  //轮播图点击左边移动

  const handleClicktoLeft = () => {
    clearTimeout(mouseAn);
    clearInterval(leftInt);
    clearInterval(rightInt);
    const wrap = document.getElementsByClassName('product-wrap')[0];
    let left = Number(wrap.offsetLeft);
    if (left > -175) {
      left = 0;
    } else {
      left = left + 175;
    }
    Object.assign(wrap.style, {
      left: left + 'px',
    });
  };

  //轮播图点击右边移动

  const handleClicktoRight = () => {
    clearTimeout(mouseAn);
    clearInterval(leftInt);
    clearInterval(rightInt);
    const wrap = document.getElementsByClassName('product-wrap')[0];
    let left = Number(wrap.offsetLeft);
    const productListRefW = productListRef?.current?.offsetWidth;
    const productListBoxRefW = productListBoxRef?.current?.offsetWidth;
    if (
      (productListBoxRefW - left - productListRefW > -175 &&
        productListBoxRefW - left - productListRefW < 0) ||
      productListBoxRefW - left >= productListRefW
    ) {
      console.log(1);
      left = -(productListRefW - productListBoxRefW) - 14;
    } else {
      console.log(2);
      left -= 175;
    }
    Object.assign(wrap.style, {
      left: left + 'px',
    });
  };

  useEffect(() => {
    window.addEventListener('resize', slidingStatusFun, false);
    return () => {
      window.removeEventListener('resize', slidingStatusFun);
    };
  }, []);

  useEffect(() => {}, []);

  const slidingStatusFun = () => {
    const productListRefW = productListRef?.current?.offsetWidth;
    const productListBoxRefW = productListBoxRef?.current?.offsetWidth;
    if (productListRefW >= productListBoxRefW) {
      setStatus(1);
    } else {
      setStatus(0);
    }
  };

  const handleMouseEnter = (type) => () => {
    mouseAn = setTimeout(() => {
      type === 1 && handleMovetoRight();
      type === 0 && handleMovetoLeft();
    }, startTime);
  };

  const handleMouseLeave = () => () => {
    clearTimeout(mouseAn);
    clearInterval(leftInt);
    clearInterval(rightInt);
  };

  const productListRefW = productListRef?.current?.offsetWidth;
  const productListBoxRefW = productListBoxRef?.current?.offsetWidth;

  return (
    <ProductListStyled theme={theme}>
      <Loading loading={loading}>
        {(productListRefW >= productListBoxRefW || status === 1) && (
          <div
            className="arrow-left"
            onClick={() => handleClicktoLeft()}
            onMouseEnter={handleMouseEnter(0)}
            onMouseLeave={handleMouseLeave(0)}
          >
            <SvgIcon name={'arrow-right'} size={21} fill="#1565C0" />
          </div>
        )}
        <div className="season-hot-wrap">
          <SvgIcon name={'hot'} size={22} fill="#1565C0" />
          <span>
            {/* 当季主推款 */}
            {formatMessage({ id: 'report.health.n06.lbl01' })}
          </span>
        </div>
        <div className="product-scroll-wrap" ref={productListBoxRef}>
          <Box className="product-wrap">
            <Box className="product-display" ref={productListRef}>
              {productList &&
                productList.map((item, index) => (
                  <Box
                    className="product-box-wrap"
                    key={item?.materialCode || index}
                  >
                    <img src={item.posterUrl} alt="" className="product-img" />
                    <div className="product-box">
                      <div className="product-box-title">
                        {item.hotProductName}
                      </div>
                      <div className="product-box-code">
                        <span>
                          {formatMessage({ id: 'report.health.n06.lbl06' })}
                        </span>
                        <span>{item?.materialCode}</span>
                      </div>
                      <div className="product-box-paa">
                        <div className="paa-item">
                          <span className="box-paa">
                            {formatMessage({ id: 'report.health.n06.lbl02' })}
                            <TooltipsML
                              title={formatMessage({
                                id: 'report.health.n06.tip01',
                              })}
                            ></TooltipsML>
                          </span>
                          <span className="paa-number">
                            {fmtThousand(item.salesNum)}
                          </span>
                        </div>
                        <div className="paa-item">
                          <span className="box-paa">
                            {formatMessage({ id: 'report.health.n06.lbl03' })}
                            <TooltipsML
                              title={formatMessage({
                                id: 'report.health.n06.tip02',
                              })}
                            ></TooltipsML>
                          </span>
                          <span className="paa-number">
                            {fmtThousand(item.remainingTickets)}
                          </span>
                        </div>
                        <div className="paa-item">
                          <span className="box-paa">
                            {formatMessage({ id: 'report.health.n06.lbl04' })}
                            <TooltipsML
                              title={formatMessage({
                                id: 'report.health.n06.tip03',
                              })}
                            ></TooltipsML>
                          </span>
                          <span className="paa-number">
                            {fmtThousand(item.salesAmount)}
                          </span>
                        </div>
                        <div className="paa-item">
                          <span className="box-paa">
                            {formatMessage({ id: 'report.health.n06.lbl05' })}
                            <TooltipsML
                              title={
                                <>
                                  {formatMessage({
                                    id: 'report.health.n06.tip04',
                                  })}
                                  <br />
                                  {formatMessage({
                                    id: 'report.health.n06.tip05',
                                  })}
                                  <br />
                                  {formatMessage({
                                    id: 'report.health.n06.tip06',
                                  })}
                                </>
                              }
                            ></TooltipsML>
                          </span>
                          <span className="paa-number">
                            {fmtPercent(item.occupancyRate, 2)}
                          </span>
                        </div>
                      </div>
                    </div>
                  </Box>
                ))}
            </Box>
          </Box>
          {!loading && productList?.length < 1 && (
            <div className="nodata-wrap">
              <NoData loading={loading} />
            </div>
          )}
        </div>
        {(productListRefW >= productListBoxRefW || status === 1) && (
          <div
            className="arrow-right"
            onClick={() => handleClicktoRight()}
            onMouseEnter={handleMouseEnter(1)}
            onMouseLeave={handleMouseLeave(1)}
          >
            <SvgIcon name={'arrow-right'} size={21} fill="#1565C0" />
          </div>
        )}
      </Loading>
    </ProductListStyled>
  );
};

export default ProductList;
